import { MessageModel } from '../typings/messaging/messages';
import { MessageStatuses } from '../enums/messaging/messages';

export function isMessageNew(message: MessageModel, currentUserId: string) {
  return (
    message.status.id === MessageStatuses.New &&
    message.from.id !== currentUserId
  );
}
